export enum RotationState {
    Front = "Front",
    Rotated = "Rotated",
    Back = "Back",
    Unknown = "Unknown",
}

export enum RotationError {
    rotatedTooQuickly = "rotatedTooQuickly",
    overRotation = "overRotation",
    underRotation = "underRotation",
    bodyOutOfView = "bodyOutOfView",
    deviceMoved = "deviceMoved",
    bodyNotDetected = "bodyNotDetected",
    insufficientRotationData = "insufficientRotationData",
}